import { Grid } from '@mui/material'
import React from 'react'
import { Select } from '@e3dc-react/shell/Elements/Select'
import { ChartType, ChartView } from '../../shared/utils/chartModel'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface ViewsProps {
  chartViews: Record<ChartView, ChartType>
  setChartViews: React.Dispatch<React.SetStateAction<Record<ChartView, ChartType> | undefined>>
}

const Views: React.FC<ViewsProps> = ({ chartViews, setChartViews }) => {
  const { t } = useCustomTranslation()

  return (
    <>
      {Object.keys(chartViews).map(view => (
        <Grid item key={view} xs={12} sm={3}>
          <Select
            options={[
              { label: t('systemDataHandler.editor.line'), value: 'line' },
              { label: t('systemDataHandler.editor.bar'), value: 'bar' },
            ]}
            label={t(`common.${view}`)}
            value={chartViews[view as ChartView]}
            onChange={(value: ChartType) => setChartViews(views => (views ? { ...views, [view]: value } : undefined))}
          />
        </Grid>
      ))}
    </>
  )
}

export default Views
